export default {
  pages: {
    offerDemandsShow: {
      goToOfflineItems: 'Перейти на офлайн товар',
    },
  },
};
